import { render, staticRenderFns } from "./template.html?vue&type=template&id=9a3ec478&"
import script from "./BoxArchivesHotelEn.vue?vue&type=script&lang=ts&"
export * from "./BoxArchivesHotelEn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports